import { apiRequest } from './client'
import type { SilkContest, SilkWork } from './types'
import type { SilkProductionTask } from './tasks'

export type PlatformTenantBrief = {
  tenant_id: number
  tenant_code: string
  tenant_name: string
}

export type PlatformCatalogContest = SilkContest & PlatformTenantBrief
export type PlatformCatalogTask = SilkProductionTask & PlatformTenantBrief
export type PlatformCatalogWork = SilkWork & PlatformTenantBrief

type ListQuery = {
  limit?: number
  offset?: number
  tenant_id?: number
  status?: string
  category_code?: string
  category?: string
  order?: string
  q?: string
}

export const platformCatalogApi = {
  listContests: (params?: ListQuery) =>
    apiRequest<{ total: number; items: PlatformCatalogContest[] }>('/api/v1/platform/contests', {
      query: params,
      auth: false,
    }),

  listTasks: (params?: ListQuery) =>
    apiRequest<{ total: number; items: PlatformCatalogTask[] }>('/api/v1/platform/tasks', {
      query: params,
      auth: false,
    }),

  listWorks: (params?: ListQuery) =>
    apiRequest<{ total: number; items: PlatformCatalogWork[] }>('/api/v1/platform/works', {
      query: params,
      auth: false,
    }),
}
